/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SopralluoghiRouteImport } from './routes/sopralluoghi'
import { Route as ScdBoardRouteImport } from './routes/scd-board'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ProfessionalsRouteImport } from './routes/professionals'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as PartecipazioniRouteImport } from './routes/partecipazioni'
import { Route as MessaggiRouteImport } from './routes/messaggi'
import { Route as MatchRouteImport } from './routes/match'
import { Route as LottiRouteImport } from './routes/lotti'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KpiRouteImport } from './routes/kpi'
import { Route as ClientiRouteImport } from './routes/clienti'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SopralluoghiIdRouteImport } from './routes/sopralluoghi.$id'
import { Route as ScdBoardIdRouteImport } from './routes/scd-board.$id'
import { Route as PipelinePostAggRouteImport } from './routes/pipeline.post-agg'
import { Route as PartecipazioniIdRouteImport } from './routes/partecipazioni.$id'
import { Route as LottiIdRouteImport } from './routes/lotti.$id'
import { Route as ClientiIdRouteImport } from './routes/clienti.$id'
import { Route as AdminScrapeRouteImport } from './routes/admin.scrape'
import { Route as LottiIdMatchRouteImport } from './routes/lotti.$id.match'
import { Route as ClientiIdMatchRouteImport } from './routes/clienti.$id.match'

const SopralluoghiRoute = SopralluoghiRouteImport.update({
  id: '/sopralluoghi',
  path: '/sopralluoghi',
  getParentRoute: () => rootRouteImport,
} as any)
const ScdBoardRoute = ScdBoardRouteImport.update({
  id: '/scd-board',
  path: '/scd-board',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfessionalsRoute = ProfessionalsRouteImport.update({
  id: '/professionals',
  path: '/professionals',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const PartecipazioniRoute = PartecipazioniRouteImport.update({
  id: '/partecipazioni',
  path: '/partecipazioni',
  getParentRoute: () => rootRouteImport,
} as any)
const MessaggiRoute = MessaggiRouteImport.update({
  id: '/messaggi',
  path: '/messaggi',
  getParentRoute: () => rootRouteImport,
} as any)
const MatchRoute = MatchRouteImport.update({
  id: '/match',
  path: '/match',
  getParentRoute: () => rootRouteImport,
} as any)
const LottiRoute = LottiRouteImport.update({
  id: '/lotti',
  path: '/lotti',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KpiRoute = KpiRouteImport.update({
  id: '/kpi',
  path: '/kpi',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientiRoute = ClientiRouteImport.update({
  id: '/clienti',
  path: '/clienti',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SopralluoghiIdRoute = SopralluoghiIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SopralluoghiRoute,
} as any)
const ScdBoardIdRoute = ScdBoardIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ScdBoardRoute,
} as any)
const PipelinePostAggRoute = PipelinePostAggRouteImport.update({
  id: '/post-agg',
  path: '/post-agg',
  getParentRoute: () => PipelineRoute,
} as any)
const PartecipazioniIdRoute = PartecipazioniIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PartecipazioniRoute,
} as any)
const LottiIdRoute = LottiIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LottiRoute,
} as any)
const ClientiIdRoute = ClientiIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ClientiRoute,
} as any)
const AdminScrapeRoute = AdminScrapeRouteImport.update({
  id: '/admin/scrape',
  path: '/admin/scrape',
  getParentRoute: () => rootRouteImport,
} as any)
const LottiIdMatchRoute = LottiIdMatchRouteImport.update({
  id: '/match',
  path: '/match',
  getParentRoute: () => LottiIdRoute,
} as any)
const ClientiIdMatchRoute = ClientiIdMatchRouteImport.update({
  id: '/match',
  path: '/match',
  getParentRoute: () => ClientiIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/clienti': typeof ClientiRouteWithChildren
  '/kpi': typeof KpiRoute
  '/login': typeof LoginRoute
  '/lotti': typeof LottiRouteWithChildren
  '/match': typeof MatchRoute
  '/messaggi': typeof MessaggiRoute
  '/partecipazioni': typeof PartecipazioniRouteWithChildren
  '/pipeline': typeof PipelineRouteWithChildren
  '/professionals': typeof ProfessionalsRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scd-board': typeof ScdBoardRouteWithChildren
  '/sopralluoghi': typeof SopralluoghiRouteWithChildren
  '/admin/scrape': typeof AdminScrapeRoute
  '/clienti/$id': typeof ClientiIdRouteWithChildren
  '/lotti/$id': typeof LottiIdRouteWithChildren
  '/partecipazioni/$id': typeof PartecipazioniIdRoute
  '/pipeline/post-agg': typeof PipelinePostAggRoute
  '/scd-board/$id': typeof ScdBoardIdRoute
  '/sopralluoghi/$id': typeof SopralluoghiIdRoute
  '/clienti/$id/match': typeof ClientiIdMatchRoute
  '/lotti/$id/match': typeof LottiIdMatchRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clienti': typeof ClientiRouteWithChildren
  '/kpi': typeof KpiRoute
  '/login': typeof LoginRoute
  '/lotti': typeof LottiRouteWithChildren
  '/match': typeof MatchRoute
  '/messaggi': typeof MessaggiRoute
  '/partecipazioni': typeof PartecipazioniRouteWithChildren
  '/pipeline': typeof PipelineRouteWithChildren
  '/professionals': typeof ProfessionalsRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scd-board': typeof ScdBoardRouteWithChildren
  '/sopralluoghi': typeof SopralluoghiRouteWithChildren
  '/admin/scrape': typeof AdminScrapeRoute
  '/clienti/$id': typeof ClientiIdRouteWithChildren
  '/lotti/$id': typeof LottiIdRouteWithChildren
  '/partecipazioni/$id': typeof PartecipazioniIdRoute
  '/pipeline/post-agg': typeof PipelinePostAggRoute
  '/scd-board/$id': typeof ScdBoardIdRoute
  '/sopralluoghi/$id': typeof SopralluoghiIdRoute
  '/clienti/$id/match': typeof ClientiIdMatchRoute
  '/lotti/$id/match': typeof LottiIdMatchRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/clienti': typeof ClientiRouteWithChildren
  '/kpi': typeof KpiRoute
  '/login': typeof LoginRoute
  '/lotti': typeof LottiRouteWithChildren
  '/match': typeof MatchRoute
  '/messaggi': typeof MessaggiRoute
  '/partecipazioni': typeof PartecipazioniRouteWithChildren
  '/pipeline': typeof PipelineRouteWithChildren
  '/professionals': typeof ProfessionalsRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scd-board': typeof ScdBoardRouteWithChildren
  '/sopralluoghi': typeof SopralluoghiRouteWithChildren
  '/admin/scrape': typeof AdminScrapeRoute
  '/clienti/$id': typeof ClientiIdRouteWithChildren
  '/lotti/$id': typeof LottiIdRouteWithChildren
  '/partecipazioni/$id': typeof PartecipazioniIdRoute
  '/pipeline/post-agg': typeof PipelinePostAggRoute
  '/scd-board/$id': typeof ScdBoardIdRoute
  '/sopralluoghi/$id': typeof SopralluoghiIdRoute
  '/clienti/$id/match': typeof ClientiIdMatchRoute
  '/lotti/$id/match': typeof LottiIdMatchRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clienti'
    | '/kpi'
    | '/login'
    | '/lotti'
    | '/match'
    | '/messaggi'
    | '/partecipazioni'
    | '/pipeline'
    | '/professionals'
    | '/profile'
    | '/reset-password'
    | '/scd-board'
    | '/sopralluoghi'
    | '/admin/scrape'
    | '/clienti/$id'
    | '/lotti/$id'
    | '/partecipazioni/$id'
    | '/pipeline/post-agg'
    | '/scd-board/$id'
    | '/sopralluoghi/$id'
    | '/clienti/$id/match'
    | '/lotti/$id/match'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clienti'
    | '/kpi'
    | '/login'
    | '/lotti'
    | '/match'
    | '/messaggi'
    | '/partecipazioni'
    | '/pipeline'
    | '/professionals'
    | '/profile'
    | '/reset-password'
    | '/scd-board'
    | '/sopralluoghi'
    | '/admin/scrape'
    | '/clienti/$id'
    | '/lotti/$id'
    | '/partecipazioni/$id'
    | '/pipeline/post-agg'
    | '/scd-board/$id'
    | '/sopralluoghi/$id'
    | '/clienti/$id/match'
    | '/lotti/$id/match'
  id:
    | '__root__'
    | '/'
    | '/clienti'
    | '/kpi'
    | '/login'
    | '/lotti'
    | '/match'
    | '/messaggi'
    | '/partecipazioni'
    | '/pipeline'
    | '/professionals'
    | '/profile'
    | '/reset-password'
    | '/scd-board'
    | '/sopralluoghi'
    | '/admin/scrape'
    | '/clienti/$id'
    | '/lotti/$id'
    | '/partecipazioni/$id'
    | '/pipeline/post-agg'
    | '/scd-board/$id'
    | '/sopralluoghi/$id'
    | '/clienti/$id/match'
    | '/lotti/$id/match'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClientiRoute: typeof ClientiRouteWithChildren
  KpiRoute: typeof KpiRoute
  LoginRoute: typeof LoginRoute
  LottiRoute: typeof LottiRouteWithChildren
  MatchRoute: typeof MatchRoute
  MessaggiRoute: typeof MessaggiRoute
  PartecipazioniRoute: typeof PartecipazioniRouteWithChildren
  PipelineRoute: typeof PipelineRouteWithChildren
  ProfessionalsRoute: typeof ProfessionalsRoute
  ProfileRoute: typeof ProfileRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ScdBoardRoute: typeof ScdBoardRouteWithChildren
  SopralluoghiRoute: typeof SopralluoghiRouteWithChildren
  AdminScrapeRoute: typeof AdminScrapeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sopralluoghi': {
      id: '/sopralluoghi'
      path: '/sopralluoghi'
      fullPath: '/sopralluoghi'
      preLoaderRoute: typeof SopralluoghiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scd-board': {
      id: '/scd-board'
      path: '/scd-board'
      fullPath: '/scd-board'
      preLoaderRoute: typeof ScdBoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/professionals': {
      id: '/professionals'
      path: '/professionals'
      fullPath: '/professionals'
      preLoaderRoute: typeof ProfessionalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partecipazioni': {
      id: '/partecipazioni'
      path: '/partecipazioni'
      fullPath: '/partecipazioni'
      preLoaderRoute: typeof PartecipazioniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messaggi': {
      id: '/messaggi'
      path: '/messaggi'
      fullPath: '/messaggi'
      preLoaderRoute: typeof MessaggiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/match': {
      id: '/match'
      path: '/match'
      fullPath: '/match'
      preLoaderRoute: typeof MatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lotti': {
      id: '/lotti'
      path: '/lotti'
      fullPath: '/lotti'
      preLoaderRoute: typeof LottiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kpi': {
      id: '/kpi'
      path: '/kpi'
      fullPath: '/kpi'
      preLoaderRoute: typeof KpiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clienti': {
      id: '/clienti'
      path: '/clienti'
      fullPath: '/clienti'
      preLoaderRoute: typeof ClientiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sopralluoghi/$id': {
      id: '/sopralluoghi/$id'
      path: '/$id'
      fullPath: '/sopralluoghi/$id'
      preLoaderRoute: typeof SopralluoghiIdRouteImport
      parentRoute: typeof SopralluoghiRoute
    }
    '/scd-board/$id': {
      id: '/scd-board/$id'
      path: '/$id'
      fullPath: '/scd-board/$id'
      preLoaderRoute: typeof ScdBoardIdRouteImport
      parentRoute: typeof ScdBoardRoute
    }
    '/pipeline/post-agg': {
      id: '/pipeline/post-agg'
      path: '/post-agg'
      fullPath: '/pipeline/post-agg'
      preLoaderRoute: typeof PipelinePostAggRouteImport
      parentRoute: typeof PipelineRoute
    }
    '/partecipazioni/$id': {
      id: '/partecipazioni/$id'
      path: '/$id'
      fullPath: '/partecipazioni/$id'
      preLoaderRoute: typeof PartecipazioniIdRouteImport
      parentRoute: typeof PartecipazioniRoute
    }
    '/lotti/$id': {
      id: '/lotti/$id'
      path: '/$id'
      fullPath: '/lotti/$id'
      preLoaderRoute: typeof LottiIdRouteImport
      parentRoute: typeof LottiRoute
    }
    '/clienti/$id': {
      id: '/clienti/$id'
      path: '/$id'
      fullPath: '/clienti/$id'
      preLoaderRoute: typeof ClientiIdRouteImport
      parentRoute: typeof ClientiRoute
    }
    '/admin/scrape': {
      id: '/admin/scrape'
      path: '/admin/scrape'
      fullPath: '/admin/scrape'
      preLoaderRoute: typeof AdminScrapeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lotti/$id/match': {
      id: '/lotti/$id/match'
      path: '/match'
      fullPath: '/lotti/$id/match'
      preLoaderRoute: typeof LottiIdMatchRouteImport
      parentRoute: typeof LottiIdRoute
    }
    '/clienti/$id/match': {
      id: '/clienti/$id/match'
      path: '/match'
      fullPath: '/clienti/$id/match'
      preLoaderRoute: typeof ClientiIdMatchRouteImport
      parentRoute: typeof ClientiIdRoute
    }
  }
}

interface ClientiIdRouteChildren {
  ClientiIdMatchRoute: typeof ClientiIdMatchRoute
}

const ClientiIdRouteChildren: ClientiIdRouteChildren = {
  ClientiIdMatchRoute: ClientiIdMatchRoute,
}

const ClientiIdRouteWithChildren = ClientiIdRoute._addFileChildren(
  ClientiIdRouteChildren,
)

interface ClientiRouteChildren {
  ClientiIdRoute: typeof ClientiIdRouteWithChildren
}

const ClientiRouteChildren: ClientiRouteChildren = {
  ClientiIdRoute: ClientiIdRouteWithChildren,
}

const ClientiRouteWithChildren =
  ClientiRoute._addFileChildren(ClientiRouteChildren)

interface LottiIdRouteChildren {
  LottiIdMatchRoute: typeof LottiIdMatchRoute
}

const LottiIdRouteChildren: LottiIdRouteChildren = {
  LottiIdMatchRoute: LottiIdMatchRoute,
}

const LottiIdRouteWithChildren =
  LottiIdRoute._addFileChildren(LottiIdRouteChildren)

interface LottiRouteChildren {
  LottiIdRoute: typeof LottiIdRouteWithChildren
}

const LottiRouteChildren: LottiRouteChildren = {
  LottiIdRoute: LottiIdRouteWithChildren,
}

const LottiRouteWithChildren = LottiRoute._addFileChildren(LottiRouteChildren)

interface PartecipazioniRouteChildren {
  PartecipazioniIdRoute: typeof PartecipazioniIdRoute
}

const PartecipazioniRouteChildren: PartecipazioniRouteChildren = {
  PartecipazioniIdRoute: PartecipazioniIdRoute,
}

const PartecipazioniRouteWithChildren = PartecipazioniRoute._addFileChildren(
  PartecipazioniRouteChildren,
)

interface PipelineRouteChildren {
  PipelinePostAggRoute: typeof PipelinePostAggRoute
}

const PipelineRouteChildren: PipelineRouteChildren = {
  PipelinePostAggRoute: PipelinePostAggRoute,
}

const PipelineRouteWithChildren = PipelineRoute._addFileChildren(
  PipelineRouteChildren,
)

interface ScdBoardRouteChildren {
  ScdBoardIdRoute: typeof ScdBoardIdRoute
}

const ScdBoardRouteChildren: ScdBoardRouteChildren = {
  ScdBoardIdRoute: ScdBoardIdRoute,
}

const ScdBoardRouteWithChildren = ScdBoardRoute._addFileChildren(
  ScdBoardRouteChildren,
)

interface SopralluoghiRouteChildren {
  SopralluoghiIdRoute: typeof SopralluoghiIdRoute
}

const SopralluoghiRouteChildren: SopralluoghiRouteChildren = {
  SopralluoghiIdRoute: SopralluoghiIdRoute,
}

const SopralluoghiRouteWithChildren = SopralluoghiRoute._addFileChildren(
  SopralluoghiRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClientiRoute: ClientiRouteWithChildren,
  KpiRoute: KpiRoute,
  LoginRoute: LoginRoute,
  LottiRoute: LottiRouteWithChildren,
  MatchRoute: MatchRoute,
  MessaggiRoute: MessaggiRoute,
  PartecipazioniRoute: PartecipazioniRouteWithChildren,
  PipelineRoute: PipelineRouteWithChildren,
  ProfessionalsRoute: ProfessionalsRoute,
  ProfileRoute: ProfileRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ScdBoardRoute: ScdBoardRouteWithChildren,
  SopralluoghiRoute: SopralluoghiRouteWithChildren,
  AdminScrapeRoute: AdminScrapeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
